<script>
export default {
    name: "FAQ",
    data() {
        return {
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
            isOpen4: false,
            isOpen5: false,
            isOpen6: false,
            isOpen7: false,
            isOpen8: false,
        }
    },
    methods: {
        toggle(faq) {
            this[faq] = !this[faq];
        },
    },
};
</script>


<template>
    <section class="faq">
        <h2>{{ __('Часто задаваемые вопросы') }}</h2>
        <div class="faq-wrapper">

            <div class="faq-container">
                <div class="faq-box" @click="toggle('isOpen1')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Что это за приложение?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen1 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen1">
                            {{ __('Автоматизированное приложение по установке игровых модификаций для игр, позволяющее получить новые эмоции, и все это в 2 клика.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen2')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Для каких игр есть модификации?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen2 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen2">
                            {{ __('Наша библиотека поддерживаемых игр постоянно расширяется и когда нибудь, мы планируем сделать возможность моддинга абсолютно во всех. Из самых популярных: Minecraft, GTA5, Sims 4, ETS2, Beam NG, World of Warcraft.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen3')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Возникла проблема с приложением, что делать?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen3 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen3">
                            {{ __('Главное, не пугайтесь. Наши специалисты тех-поддержки готовы ответить на ваши вопросы и решить любые возникшие проблемы, просто перейдите в наш Discord в канал "тех-поддержка" и создайте тикет.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen4')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Хочу стать медиа-партнером, как это сделать?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen4 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen4">
                            {{ __('Неважно стример вы, ютубер, или тиктокер вертикал - нам стоит работать вместе! Всего за пару минут общения мы сможем найти общий язык и договориться на взаимовыгодных условиях, а если заинтересовали: https://t.me/cloudpartners') }}
                        </div>
                    </transition>
                </div>
            </div>

            <div class="faq-container">
                <div class="faq-box" @click="toggle('isOpen5')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Как установить Cloud Mods?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen5 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen5">
                            {{ __('Установить можно просто нажать кнопку "Скачать" на сайте, но ведь лучше сделать это с подпиской Cloud Premium, которая открывает доступ ко всей библиотеке модификаций в приложении сразу для всех поддерживаемых игр. Это максимально выгодно и удобно.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen6')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Не забанят ли меня за скачанные модификации?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen6 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen6">
                            {{ __('Наши модификации полностью легальны, поэтому, блокировок быть не должно.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen7')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Хочу стать автором, как это сделать?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen7 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen7">
                            {{ __('В скором времени мы откроем заявки и сделаем удобную панель для авторов. Следите за подробностями в наших соц. сетях.') }}
                        </div>
                    </transition>
                </div>
                <div class="faq-box" @click="toggle('isOpen8')">
                    <div class="faq-title-container">
                        <div class="faq-title">{{ __('Хочу отменить подписку, как это сделать?') }}</div>
                        <svg class="arrow" :class="{ rotated: isOpen8 }" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.9446 8.33325L10.0001 13.0555L3.05566 8.33325" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <transition name="faq">
                        <div class="faq-answer" v-if="isOpen8">
                            {{ __('Отменить продление подписки можно в личном кабинете на сайте после авторизации, переяйдя в настройки - управление подписками, либо в приложении в пункте "настройки - управление подписками". Если у вас нет доступа к аккаунту, вы так же можете отменить продление через нашу тех. поддержку') }}
                        </div>
                    </transition>
                </div>
            </div>

        </div>
    </section>
</template>

<style scoped>
.faq {
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.faq-wrapper {
    display: flex;
    flex-direction: row;
}

.faq-container {
    display: flex;
    flex-direction: column;
}

.faq-box {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    background: #040404;
    border: 1px solid rgba(255, 255, 255, 0.10);
}

.faq-title-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.faq-title {
    width: 90%;
    font-weight: 600;
    color: var(--text-primary);
}

.faq-answer {
    font-weight: 500;
    color: var(--text-secondary);
}

@media (min-width: 320px) {
    .faq {
        gap: 5vw;
        padding: 5vw;
    }

    .faq-wrapper {
        flex-direction: column;
        gap: 3.75vw;
    }

    .faq-container {
        gap: 3.75vw;
    }

    .faq-box {
        width: 90vw;
        padding: 5vw 6.25vw;
        border-radius: 3.75vw;

        gap: 3.75vw;
    }

    .faq-title {
        font-size: 4.375vw;
    }

    .faq-answer {
        font-size: 4.375vw;
    }
}

@media (min-width: 464px) {
    .faq {
        gap: 16px;
        padding: 24px 0px;
    }

    .faq-wrapper {
        flex-direction: column;
        gap: 12px;
    }

    .faq-container {
        gap: 12px;
    }

    .faq-box {
        width: 464px;
        padding: 20px;
        border-radius: 12px;

        gap: 12px;
    }

    .faq-title {
        font-size: 18px;
    }

    .faq-answer {
        font-size: 16px;
    }

    .arrow {
        flex-shrink: 0;
    }
}

@media (min-width: 744px) {
    .faq {
        gap: 32px;
        padding: 28px 0px;
    }

    .faq-wrapper {
        flex-direction: column;
        gap: 12px;
    }

    .faq-container {
        gap: 12px;
    }

    .faq-box {
        width: 744px;
        padding: 20px;
        border-radius: 12px;

        gap: 12px;
    }

    .faq-title {
        font-size: 18px;
    }

    .faq-answer {
        font-size: 16px;
    }
}

@media (min-width: 984px) {
    .faq {
        gap: 24px;
        padding: 28px 0px;
    }

    .faq-wrapper {
        flex-direction: row;
        gap: 12px;
    }

    .faq-container {
        gap: 12px;
    }

    .faq-box {
        width: 486px;
        padding: 20px;
        border-radius: 12px;

        gap: 12px;
    }

    .faq-title {
        font-size: 18px;
    }

    .faq-answer {
        font-size: 16px;
    }
}

@media (min-width: 1248px) {
    .faq {
        gap: 32px;
        padding: 60px 0px;
    }

    .faq-wrapper {
        gap: 12px;
    }

    .faq-container {
        gap: 12px;
    }

    .faq-box {
        width: 618px;
        padding: 20px;
        border-radius: 12px;

        gap: 12px;
    }

    .faq-title {
        font-size: 18px;
    }

    .faq-answer {
        font-size: 16px;
    }
}

.arrow {
    transition: transform 0.3s ease;
}

.arrow.rotated {
    transform: rotate(180deg);
}

.faq-enter-active, .faq-leave-active {
    transition: max-height 0.25s ease, opacity 0.25s ease;
    overflow: hidden;
}

.faq-enter-from, .faq-leave-to {
    max-height: 0;
    opacity: 0;
}

.faq-enter-to, .faq-leave-from {
    max-height: 500px;
    opacity: 1;
}

.faq-box:hover {
    cursor: pointer;
}

</style>